import { watchAddTargetedCatalogItems } from './addTargetedCatalogItems';
import { watchDeleteTargetedCatalogItem } from './deleteTargetedCatalogItem';
import { watchDeleteTargetedCatalogSection } from './deleteTargetedCatalogSection';
import { watchDeleteTargetedItemGroup } from './deleteTargetedItemGroup';
import { watchFetchTargetedCatalog } from './fetchTargetedCatalog';
import { watchTargetedCatalogItemSearch } from './targetedCatalogItemSearch';
import { watchUpdateTargetedItemGroupOrder } from './udpateTargetedItemGroupOrder';
import { watchUpdateTargetedCatalogItemOrder } from './updateTargetedCatalogItemOrder';
import { watchUpdateTargetedCatalogSection } from './updateTargetedCatalogSection';
import { watchUpdateTargetedItemGroup } from './updateTargetedItemGroup';

export const targetedCatalogSagas = [
  watchAddTargetedCatalogItems(),
  watchDeleteTargetedCatalogItem(),
  watchDeleteTargetedCatalogSection(),
  watchDeleteTargetedItemGroup(),
  watchFetchTargetedCatalog(),
  watchTargetedCatalogItemSearch(),
  watchUpdateTargetedCatalogItemOrder(),
  watchUpdateTargetedCatalogSection(),
  watchUpdateTargetedItemGroup(),
  watchUpdateTargetedItemGroupOrder()
];
